const Commercial = () =>
    import("@/views/commercial/Commercial");

const CommercialList = () =>
    import("@/views/commercial/CommercialList");

export const CommercialListRoute = {
    path: "commercialList",
    component: CommercialList,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce", 
        breadcrumb: [
            {
                text: "Comercial",
                disabled: true,
                href: "#"
            },
            {
                text: "Reportes",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};


export const CommercialRoute = {
    path: "commercial",
    component: CommercialList,
    children: [

        CommercialListRoute,
    ]
}